import { render } from "./index.vue?vue&type=template&id=13434656&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=13434656&lang=scss&scoped=true"

import exportComponent from "C:\\wamp64\\www\\DDP\\webapp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13434656"]])

export default __exports__